import React from 'react'

interface DeviceIconProps {
  deviceType?: string | null
  size?: number
  color?: string
}

export default function DeviceIcon({ deviceType, size = 24, color = '#2D7A3A' }: DeviceIconProps) {
  if (deviceType?.startsWith('door')) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="3" y="2" width="14" height="20" rx="2" stroke={color} strokeWidth="1.8"/>
        <rect x="3" y="2" width="14" height="20" rx="2" fill={color} fillOpacity="0.08"/>
        <circle cx="14.5" cy="12" r="1.2" fill={color}/>
        <line x1="17" y1="2" x2="21" y2="5" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
        <line x1="17" y1="22" x2="21" y2="19" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
        <line x1="21" y1="5" x2="21" y2="19" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  }

  if (deviceType?.startsWith('alarm')) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M12 3a7 7 0 0 1 7 7v4l2 3H3l2-3v-4a7 7 0 0 1 7-7z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" fill={color} fillOpacity="0.08"/>
        <path d="M10 18a2 2 0 0 0 4 0" stroke={color} strokeWidth="1.8"/>
        <line x1="12" y1="3" x2="12" y2="1" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    )
  }

  // default: motion sensor (person with wave)
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="5" r="2.2" stroke={color} strokeWidth="1.8"/>
      <path d="M6 10h6l-1.5 7H7.5L6 10z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" fill={color} fillOpacity="0.08"/>
      <path d="M6 14l-2 3M12 14l2 3" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M16 8 Q19 11 16 14" stroke={color} strokeWidth="1.8" strokeLinecap="round" fill="none"/>
      <path d="M18 6 Q22 11 18 16" stroke={color} strokeWidth="1.8" strokeLinecap="round" fill="none"/>
    </svg>
  )
}
